import FormValue from "./FormValue";

export default class DataForm {

  constructor(data, asNew = false){
    this._data = data;
    this._newKeys = {};
    this._asNew = asNew;
    Object.keys(data).forEach(key => this[key] = new FormValue(data[key]));
  }

  getModifiedKeys(){
    if(this._asNew){
      return Object.keys(this).filter(k => !k.startsWith("_"));
    }
    return Object.keys(this._data).filter(k => this[k].modified);
  }

  getUpdateDto(){
    var obj = {};
    this.getModifiedKeys()
      .forEach(key => obj[key] = this[key].value);
    return obj;
  }

  get modified(){
    return this.getModifiedKeys().length != 0;
  }

  reset(){
    this.getModifiedKeys()
      .forEach(key => this[key].reset());
  }

  get dto(){
    return this.getUpdateDto();
  }

  field(fieldName){
    if(!this[fieldName]){
      this[fieldName] = new FormValue(null);
    }
    return this[fieldName];
  }

}


// WEBPACK FOOTER //
// ./src/Editor/DataForm.js